import { render } from "./FeatherSearchSvg.vue?vue&type=template&id=160f9eec"
const script = {}
script.render = render

export default script